import { createContext } from 'react';
const SVGDefsContext = createContext(undefined);
export default SVGDefsContext;
//# sourceMappingURL=SVGDefsContext.js.map